import emitter from '../bus';

type FreshchatUser = {
  firebase_user_id?: string;
  uid?: string;
  email?: string;
  display_name?: string;
  displayName?: string;
  name?: string;
};

const getFreshchatUser = (): FreshchatUser | null => {
  if (!window.user) return null;
  return window.user as FreshchatUser;
};

const setFreshchatUserData = (): boolean => {
  const user = getFreshchatUser();
  const fcWidget = (window as any).fcWidget;
  const externalId = user?.firebase_user_id || user?.uid || '';
  if (!user || !externalId || !fcWidget) return false;

  const name = user.display_name || user.displayName || user.name || '';
  const email = user.email || '';

  if (typeof fcWidget.setExternalId === 'function') {
    fcWidget.setExternalId(externalId);
  }

  if (fcWidget.user && typeof fcWidget.user.setEmail === 'function' && email) {
    fcWidget.user.setEmail(email);
  }

  if (fcWidget.user && typeof fcWidget.user.setFirstName === 'function' && name) {
    fcWidget.user.setFirstName(name);
  }

  if (fcWidget.user && typeof fcWidget.user.setProperties === 'function') {
    fcWidget.user.setProperties({
      userID: externalId,
      name,
      email
    });
  }

  return true;
};

let hasBoundWidgetLoadedHandler = false;

const bindWidgetLoadedHandler = () => {
  if (hasBoundWidgetLoadedHandler) return true;

  const fwcrm = (window as any).fwcrm;
  if (!fwcrm || typeof fwcrm.on !== 'function') return false;

  fwcrm.on('widget:loaded', setFreshchatUserData);
  hasBoundWidgetLoadedHandler = true;
  return true;
};

const retrySetFreshchatUserData = (maxAttempts = 10, intervalMs = 500) => {
  let attempts = 0;
  const interval = window.setInterval(() => {
    attempts += 1;
    const isApplied = setFreshchatUserData();
    if (isApplied || attempts >= maxAttempts) {
      window.clearInterval(interval);
    }
  }, intervalMs);
};

const bindFreshchatUserData = () => {
  setFreshchatUserData();
  bindWidgetLoadedHandler();

  retrySetFreshchatUserData(20, 500);

  emitter.on('user:updated', () => {
    setFreshchatUserData();
    bindWidgetLoadedHandler();
    retrySetFreshchatUserData(12, 500);
  });
};

bindFreshchatUserData();
